<template>
  <div class="c-l-r ivu-row-flex d-flex">
    <div class="ivu-col ivu-col-span-1 p-xs text-right text-muted">
      {{ index + 1 }}
    </div>
    <div class="ivu-col ivu-col-span-3 p-xs daam-cell text-muted">
      <i
        :class="
          `ivu-icon ivu-icon-md-${
            source.isSeen ? 'checkbox' : 'square'
          }-outline ${source.isSeen ? 'text-success' : 'text-muted'}`
        "
        style="font-size: 24px;"
      ></i>
      <span v-if="source.isSeen">{{ source.seenDate | moment("HH:mm") }}</span>
    </div>

    <div class="ivu-col ivu-col-span-5 p-xs daam-cell">
      <a
        @click="$parent.$parent.$emit('show-user', source.id)"
        :style="{ color: source.isSeen ? 'black' : 'gray' }"
      >
        <div class="avatar avatar-sm" style="width: 16px; height: 16px">
          <img class="m-r-xs" :src="source.user.avator" />
        </div>
        {{ source.user.fullName }}
      </a>
    </div>
    <div class="ivu-col ivu-col-span-3 p-xs daam-cell text-muted text-right">
      {{ source.user.mobile }}
    </div>
    <div class="ivu-col ivu-col-span-2 p-xs daam-cell text-muted text-right">
      {{ source.user.register }}
    </div>
    <div class="ivu-col ivu-col-span-9 p-xs text-muted-xl daam-cell">
      {{ source.user.departName }}
      <i class="ivu-icon ivu-icon-ios-arrow-forward"></i>
      {{ source.user.position }}
    </div>
  </div>
</template>

<script>
export default {
  name: "item-component",
  props: {
    index: {
      // index of current item
      type: Number
    },
    source: {
      // here is: {uid: 'unique_1', text: 'abc'}
      type: Object,
      default() {
        return {};
      }
    }
  }
};
</script>
